import React from 'react';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

import { useForm } from 'react-hook-form';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { useDispatch, useSelector } from 'react-redux';
import {
  UpdateSparePartListing,
  getCarBrand,
  getAllParts,
  DeleteSparePartParts,
  AddSparePartsPart,
  UpdateSparePartPart,
  getSparePartListing,
} from './../../../../Redux/Actions/UserAction';
import Sidebar from '../../../common/Sidebar/Sidebar';
import { useTranslation } from 'react-i18next';
import { CommonBusinessHeader } from '../CommonBusinessHeader';
import Swal from 'sweetalert2';

export default function SparePartsParts() {
  const { t, i18n } = useTranslation();
  const isRTL = (i18n.language || 'en').toLowerCase().startsWith('ar');
  // Part names are bilingual in the DB: `name` (English), `nameAr` (Arabic).
  const partLabel = (p) =>
    isRTL ? p?.nameAr || p?.name : p?.name || p?.nameAr;

  const dispatch = useDispatch();

  const home = useSelector((state) => state?.home);
  const SparePartList = home?.SparePartList;
  const CarBrandList = home?.garageCarBrandList;
  const getSpareParts = home?.getSpareParts;
  const businessDetail = home?.getMybusiness;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'all' });

  const [slected, setslected] = useState([]);
  const [slectedProduct, setslectedProduct] = useState([]);

  const [index1, setIndex] = useState(0);

  const [parts, setparts] = useState([
    {
      partId: '',
      productIds: [],
      brands: [],
    },
  ]);

  // [CF] The add-part input rows (and the "Add Car Brands"/"Add Vehicles"
  // control) should only be visible while the owner is actively adding a part.
  // Hidden by default; toggled by "Add Parts"; hidden again after a successful
  // save. This stops the empty/last input row from lingering under the saved
  // list once a part has been added.
  const [isAdding, setIsAdding] = useState(false);

  // [CF] Remembers WHICH saved part is currently being edited
  // (sparePartsOwnerPartId). When set, submitting does a true in-place update
  // via the backend PUT (updates brands + products of that part; partId stays
  // the same) instead of adding a new part. Cleared on reset / after submit.
  const [editingOwnerPartId, setEditingOwnerPartId] = useState(null);

  // [CF] Reset the add-form back to a single empty row and clear the per-row
  // brand/product selection state (brands were carrying over from the last
  // added part).
  const resetPartRows = () => {
    setparts([{ partId: '', productIds: [], brands: [] }]);
    setslected([]);
    setslectedProduct([]);
    setIndex(0);
    setEditingOwnerPartId(null);
  };

  const handleInputAdd = (e, indexValue) => {
    console.log('this is hendelar', indexValue);
    // const { name, value } = e.target;
    const list = [...parts];
    list[index1].partId = e;
    setparts(list);
  };

  const handleAddBrand = (e, i, Value, brandid) => {
    console.log(index1);

    const list = [...parts];
    let SELECT_ARR = [...slected, brandid];

    if (list[index1].brands.includes(Value)) {
      list[index1].brands = list[index1].brands.filter(
        (brand) => brand !== Value
      );
    } else {
      list[index1].brands = [...parts[index1].brands, Value];
    }

    if (slected.includes(brandid)) {
      SELECT_ARR = SELECT_ARR.filter((id) => id !== brandid);
    }

    setparts(list);
    setslected(SELECT_ARR);
  };

  const handleAddProduct = (e, i, Value, productId) => {
    console.log(index1);

    console.log('addProducts', Value, productId);

    const list = [...parts];
    let SELECT_ARR = [...slectedProduct, productId];

    if (list[index1].productIds.includes(Value)) {
      list[index1].productIds = list[index1].productIds.filter(
        (product) => product !== Value
      );
    } else {
      list[index1].productIds = [...parts[index1].productIds, Value];
    }

    if (slected.includes(productId)) {
      SELECT_ARR = SELECT_ARR.filter((id) => id !== productId);
    }

    setparts(list);
    setslectedProduct(SELECT_ARR);
  };

  // console.log(services);
  const handleRemoveClick = (index) => {
    const list = [...parts];
    list.splice(index, 1);
    setparts(list);
  };

  const handleAddClick = (e) => {
    // First click opens the (hidden-by-default) input area with one empty row.
    // Subsequent clicks while already adding append another empty row.
    if (!isAdding) {
      setIsAdding(true);
      resetPartRows();
      return;
    }
    setparts([
      ...parts,

      {
        partId: '',
        productIds: [],
        brands: [],
      },
    ]);
  };

  // [CF] Prefill the add-form from an existing saved part so the owner can
  // re-enter it with changes. We remember the sparePartsOwnerPartId so saving
  // does a true in-place update (backend PUT — updates brands + products of the
  // existing part) instead of creating a new entry.
  const onEditPart = (dt) => {
    const brandIds = (dt?.brands || [])
      .map((b) => b?.brandId ?? b?.brand?.brandId)
      .filter((id) => id !== undefined && id !== null);
    const productIds = (dt?.part?.partProducts || [])
      .map((p) => p?.productId ?? p?.product?.productId)
      .filter((id) => id !== undefined && id !== null);
    setIsAdding(true);
    setEditingOwnerPartId(dt?.sparePartsOwnerPartId ?? null);
    setparts([
      {
        partId: dt?.partId ?? dt?.part?.partId ?? '',
        productIds,
        brands: brandIds,
      },
    ]);
    setslected(brandIds);
    setslectedProduct(productIds);
    setIndex(0);
    /* [CF 2026-08-17 SP9] Editing reuses the ADD form, which renders below the
       saved parts — so clicking the pencil looked like a brand-new empty row had
       been appended to the bottom of the list. The record IS updated (the PUT
       below keys off editingOwnerPartId, so nothing is duplicated); it simply
       did not read as an edit. Scroll the form into view so the user follows
       where they were taken; the heading above it now says which part is being
       edited. */
    setTimeout(() => {
      const el = document.getElementById('cav-part-form');
      if (el && el.scrollIntoView) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 60);
  };

  // The owner's business id can arrive two ways after a reload: from Redux
  // (getMybusiness) or from sessionStorage (set by the Header once /business/my
  // resolves). Prefer whichever is available so the saved parts refetch and
  // repopulate after a reload (previously they vanished until a tab switch).
  const ownerBid =
    (businessDetail?.businessId && String(businessDetail.businessId)) ||
    sessionStorage.getItem('BusinessId');
  const validBid =
    ownerBid &&
    ownerBid !== 'undefined' &&
    ownerBid !== 'null' &&
    ownerBid !== '';

  useEffect(() => {
    dispatch(getCarBrand());
    dispatch(getAllParts(sessionStorage.getItem('ownerID')));
  }, [dispatch]);

  useEffect(() => {
    if (validBid) {
      dispatch(getSparePartListing(ownerBid));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ownerBid]);

  // Empty selections post '' which is an invalid UUID for the FK columns and
  // makes the backend reject the whole part. Convert blanks to null so optional
  // fields are simply omitted.
  const clean = (obj) => {
    const out = {};
    Object.keys(obj).forEach((k) => {
      out[k] = obj[k] === '' ? null : obj[k];
    });
    return out;
  };

  // [CF] At least one part (a selected partId) is required. Keep only valid
  // parts and give a clear message if none are selected. The Submit button is
  // also disabled until there is a valid part (see `hasValidPart`).
  const validParts = parts.filter(
    (p) => p?.partId && String(p.partId).trim()
  );
  const hasValidPart = validParts.length > 0;

  const datasubmit = () => {
    if (!hasValidPart) {
      Swal.fire({
        title: t('Please add a spare part before submitting'),
        icon: 'error',
        confirmButtonColor: '#3ab1f7',
        confirmButtonText: t('Ok'),
      });
      return;
    }

    if (editingOwnerPartId) {
      // [CF] In-place edit: update the existing saved part via the backend PUT
      // instead of adding a new one. The edit changes brands + products of the
      // part (partId is not changed). We edit one part at a time, so use the
      // first valid row.
      const edited = validParts[0];
      dispatch(
        UpdateSparePartPart({
          parts: [
            {
              sparePartsOwnerPartId: editingOwnerPartId,
              brands: Array.isArray(edited?.brands) ? edited.brands : [],
              productIds: Array.isArray(edited?.productIds)
                ? edited.productIds
                : [],
            },
          ],
        })
      );
    } else {
      const payload = validParts.map((p) =>
        clean({
          brands: p?.brands,
          partId: p?.partId,
          productIds: p?.productIds,
        })
      );
      dispatch(AddSparePartsPart(payload));
      console.log('this is parts data section ', payload);
    }

    // [CF] After a successful add/edit, collapse the add UI and reset the input
    // rows (incl. brand/product selections + editingOwnerPartId) so the last
    // item doesn't stay stuck in the input area and brands don't carry over.
    setIsAdding(false);
    resetPartRows();
  };

  const sideBarOpt = [
    {
      icon: 'assets/images/icons/sp-business/manage-business.svg',
      link: '/sp-spare-parts-business',
      label: t('Manage Business'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-service.svg',
      link: '/sp-spare-parts-parts',
      label: t('Manage Parts'),
    },
    {
      icon: 'assets/images/icons/sp-business/banner.svg',
      link: '/sp-spare-parts-banner',
      label: t('Banner'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-working-hours.svg',
      link: '/sp-spare-parts-working-hours',
      label: t('Manage Working Hours'),
    },
  ];

  const onEditPackage = (pack) => {
    // setEdit(true)
    // setCarInsuranceData({
    // 	...pack
    // })
  };

  const onDeletePart = (partId, sparePartsOwnerPartId) => {
    // [CF-15] Confirm before deleting (was deleting instantly).
    Swal.fire({
      title: t('Are you sure?'),
      text: t('This item will be permanently deleted.'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: t('Yes, delete it'),
      cancelButtonText: t('Cancel'),
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          DeleteSparePartParts({
            partId,
            sparePartsOwnerPartId,
          })
        );
      }
    });
  };

  const isPaymentPlanActive = sessionStorage.getItem('paymentPlan');

  console.log('getSpareParts', getSpareParts);
  return (
    <div>
      <CommonBusinessHeader
        dataList={SparePartList}
        getNameKey="sparePartOwnerName"
      />

      <div class="main-content-area">
        <div class="container">
          <div class="row justify-content-between">
            <Sidebar options={sideBarOpt} />

            <div class="col-12 col-sm-12 col-md-9 col-lg-9">
              <form onSubmit={handleSubmit(datasubmit)}>
                <h2 class="mb-4">{t('Manage Services')}</h2>

                {/* [CF] "Add Parts" opens the add flow. The input rows and the
                    "Add Car Brands"/"Add Vehicles" controls only appear while
                    adding — they are no longer a permanent tab. */}
                <div class="row mb-2">
                  <div class="col-12">
                    <button
                      type="button"
                      id="btnAdd-2"
                      class="btn btn-warning"
                      onClick={handleAddClick}
                    >
                      {isAdding ? t('Add another row') : t('Add Parts')}
                    </button>
                    {isAdding && (
                      <button
                        type="button"
                        class="btn btn-secondary ml-2"
                        onClick={() => {
                          setIsAdding(false);
                          resetPartRows();
                        }}
                      >
                        {t('Cancel')}
                      </button>
                    )}
                  </div>
                </div>

                {/* [CF] Saved parts list — redesigned as clean cards: part type
                    as the title, brands and products shown as readable chips,
                    Edit/Delete as clear buttons. (Was cramped misaligned columns
                    with a bare "PART" label.) */}
                {SparePartList?.[0]?.parts?.length > 0 && (
                  <div
                    style={{
                      fontSize: '0.74rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em',
                      color: '#8a8a8a',
                      fontWeight: 700,
                      margin: '6px 0 10px',
                    }}
                  >
                    {t('Your parts')} ({SparePartList[0].parts.length})
                  </div>
                )}
                <div>
                  {SparePartList?.[0]?.parts &&
                  SparePartList?.[0]?.parts?.length ? (
                    SparePartList[0].parts.map((dt, ind) => (
                      <div
                        key={dt?.sparePartsOwnerPartId ?? ind}
                        style={{
                          border: '1px solid #ececec',
                          borderRadius: '12px',
                          padding: '16px 18px',
                          marginBottom: '12px',
                          background: '#fff',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                        }}
                      >
                        <div
                          className="d-flex justify-content-between align-items-start"
                          style={{ gap: '12px' }}
                        >
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div
                              style={{
                                fontWeight: 700,
                                fontSize: '1.02rem',
                                color: '#1c1c1c',
                                marginBottom: '10px',
                              }}
                            >
                              {partLabel(dt?.part)}
                            </div>
                            <div
                              className="d-flex flex-wrap align-items-center"
                              style={{ gap: '6px' }}
                            >
                              <span
                                style={{
                                  fontSize: '0.7rem',
                                  color: '#9a9a9a',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.04em',
                                  marginInlineEnd: '2px',
                                }}
                              >
                                {t('Brands')}
                              </span>
                              {dt?.brands?.length ? (
                                dt.brands.map((brand, bi) => (
                                  <span
                                    key={bi}
                                    style={{
                                      background: '#fff6da',
                                      color: '#8a6d00',
                                      border: '1px solid #ffe39c',
                                      borderRadius: '999px',
                                      padding: '2px 10px',
                                      fontSize: '0.78rem',
                                      fontWeight: 600,
                                    }}
                                  >
                                    {brand?.name}
                                  </span>
                                ))
                              ) : (
                                <span
                                  style={{ color: '#aaa', fontSize: '0.8rem' }}
                                >
                                  {t('All brands')}
                                </span>
                              )}
                            </div>
                          </div>
                          {/* [CF] Edit prefills the add-form from this saved part. */}
                          <div
                            className="d-flex"
                            style={{ gap: '8px', flexShrink: 0 }}
                          >
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-secondary"
                              onClick={() => onEditPart(dt)}
                            >
                              <i class="far fa-edit"></i> {t('Edit')}
                            </button>
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger"
                              onClick={() =>
                                onDeletePart(
                                  dt?.partId,
                                  dt?.sparePartsOwnerPartId
                                )
                              }
                            >
                              <i class="far fa-trash-alt"></i> {t('Delete')}
                            </button>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : !isAdding ? (
                    <div
                      style={{
                        textAlign: 'center',
                        color: '#9a9a9a',
                        padding: '32px 16px',
                        border: '1px dashed #e0e0e0',
                        borderRadius: '12px',
                      }}
                    >
                      {t('No parts added yet. Click "Add Parts" to get started.')}
                    </div>
                  ) : null}
                </div>

                {isAdding && (
                  <div id="cav-part-form" className="mb-2">
                    <h6 style={{ fontWeight: 700, margin: 0 }}>
                      {editingOwnerPartId ? t('Editing this part') : t('New part')}
                    </h6>
                  </div>
                )}
                {isAdding &&
                  parts.map((x, indexValue) => {
                  return (
                    <>
                      {/* [CF] Add/edit row — redesigned as a labeled card with
                          clear steps (Part Type / Car Brands / Remove) instead of
                          three unlabeled buttons. */}
                      <div id="example-2">
                        <div
                          class="row group manage-services-row align-items-end"
                          style={{
                            border: '1px solid #ffe39c',
                            background: '#fffdf5',
                            borderRadius: '12px',
                            padding: '14px 12px',
                            margin: '0 0 12px',
                          }}
                        >
                          <div class="col-12 col-sm-12 col-md-5 mb-2 mb-md-0">
                            <label
                              style={{
                                display: 'block',
                                fontSize: '0.7rem',
                                textTransform: 'uppercase',
                                letterSpacing: '0.04em',
                                color: '#8a6d00',
                                fontWeight: 700,
                                marginBottom: '4px',
                              }}
                            >
                              1. {t('Part Type')}{' '}
                              <span style={{ color: '#dc3545' }}>*</span>
                            </label>
                            <a
                              class={`btn btn-block ${
                                x?.partId !== ''
                                  ? 'btn-warning'
                                  : 'btn-outline-warning'
                              }`}
                              href="javascript:void(0);"
                              role="button"
                              data-toggle="modal"
                              data-target="#add-parts-list-modal"
                              onClick={() => {
                                setIndex(indexValue);
                              }}
                            >
                              {x?.partId !== ''
                                ? partLabel(
                                    getSpareParts.filter(
                                      (data) => data.partId === x?.partId
                                    )[0]
                                  )
                                : t('Select Part')}
                            </a>
                          </div>

                          <div class="col-12 col-sm-12 col-md-5 mb-2 mb-md-0">
                            <label
                              style={{
                                display: 'block',
                                fontSize: '0.7rem',
                                textTransform: 'uppercase',
                                letterSpacing: '0.04em',
                                color: '#8a8a8a',
                                fontWeight: 700,
                                marginBottom: '4px',
                              }}
                            >
                              2. {t('Car Brands')}{' '}
                              <span
                                style={{ textTransform: 'none', color: '#aaa' }}
                              >
                                ({t('Optional')})
                              </span>
                            </label>
                            <a
                              class="btn btn-outline-secondary btn-block"
                              href="javascript:void(0);"
                              role="button"
                              data-toggle="modal"
                              data-target="#add-car-brands-modal"
                              onClick={() => {
                                setIndex(indexValue);
                              }}
                            >
                              <i class="fas fa-plus"></i> {t('Add Car Brands')}
                            </a>
                          </div>

                          <div class="col-12 col-sm-12 col-md-2">
                            {parts.length !== 1 && (
                              <button
                                type="button"
                                class="btn btn-outline-danger btn-block btnRemove"
                                onClick={() => handleRemoveClick(indexValue)}
                              >
                                <i class="far fa-trash-alt"></i> {t('Remove')}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                      {/* <!-- Add Car Brands --> */}
                      <div
                        class="modal fade"
                        id="add-car-brands-modal"
                        tabindex="-1"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                      >
                        <div class="modal-dialog modal-dialog-scrollable modal-lg">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title" id="exampleModalLabel">
                                {t('Car Brands')}
                              </h5>
                              <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <div class="add-car-brands-wrap">
                                {/* <ul
                                  class="nav nav-pills mb-3"
                                  id="pills-tab"
                                  role="tablist"
                                >
                                  {CarBrandList !== undefined &&
                                  CarBrandList.length > 0
                                    ? CarBrandList.map((item) => {
                                        return (
                                          <li
                                            class="nav-item"
                                            role="presentation"
                                          >
                                            <a
                                              class="nav-link "
                                              id="pills-all-tab"
                                              data-toggle="pill"
                                              href="#pills-all"
                                              role="tab"
                                              aria-controls="pills-all"
                                              aria-selected="true"
                                            >
                                              {item.area}
                                            </a>
                                          </li>
                                        );
                                      })
                                    : ''}
                                </ul> */}
                                <div class="tab-content" id="pills-tabContent">
                                  <div
                                    class="tab-pane fade show active"
                                    id="pills-all"
                                    role="tabpanel"
                                    aria-labelledby="pills-all-tab"
                                  >
                                    <div class="row">
                                      {CarBrandList !== undefined &&
                                      CarBrandList.length > 0
                                        ? CarBrandList?.map((item, index) => {
                                            return (
                                              <div class="col-6 col-sm-6 col-md-2 mb-4">
                                                <div
                                                  class="car-brands-block"
                                                  name="brands"
                                                  id={indexValue}
                                                  onClick={(e) =>
                                                    handleAddBrand(
                                                      e,
                                                      indexValue,
                                                      item?.brandId,
                                                      item?.brandId
                                                    )
                                                  }
                                                >
                                                  <div
                                                    class="car-brands-a "
                                                    style={{
                                                      color: 'yellow',
                                                    }}
                                                    name="brands"
                                                    id={indexValue}
                                                    value={x.brands}
                                                  >
                                                    <img
                                                      id={indexValue}
                                                      style={{
                                                        opacity:
                                                          slected.includes(
                                                            item.brandId
                                                          )
                                                            ? '0.1'
                                                            : '',
                                                      }}
                                                      onClick={() => {
                                                        console.log(indexValue);
                                                      }}
                                                      src={item?.media?.path}
                                                      // src='assets/images/car-brands/all.jpg'
                                                      alt=""
                                                      class="img-fluid"
                                                      onError={(e) => {
                                                        e.target.src =
                                                          'assets/images/car-brands/all.jpg';
                                                      }}
                                                    />
                                                  </div>

                                                  <div class="car-brands-b nav-item">
                                                    {item?.name}
                                                  </div>
                                                </div>
                                              </div>
                                            );
                                          })
                                        : ''}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="modal-footer">
                              <button
                                type="button"
                                class="btn btn-primary"
                                data-dismiss="modal"
                              >
                                {t('Submit')}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <!-- Add Car Brands --> */}

                      {/* <!-- Add Parts --> */}
                      <div
                        class="modal fade"
                        id="add-parts-list-modal"
                        tabindex="-1"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                      >
                        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title">{t('Add Parts')}</h5>
                              <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <ul class="add-parts-list">
                                {getSpareParts !== undefined &&
                                getSpareParts.length > 0
                                  ? getSpareParts.map((item) => {
                                      return (
                                        <li
                                          onClick={() =>
                                            handleInputAdd(
                                              item?.partId,
                                              indexValue
                                            )
                                          }
                                          style={{
                                            opacity:
                                              parts[index1]?.partId ===
                                              item?.partId
                                                ? '0.5'
                                                : '',
                                          }}
                                        >
                                          {partLabel(item)}
                                        </li>
                                      );
                                    })
                                  : ''}
                              </ul>
                            </div>
                            <div class="modal-footer">
                              {/* <button
                                type="button"
                                class="btn btn-primary"
                                data-toggle="modal"
                                data-target="#starting-system-modal"
                                data-dismiss="modal"
                              >
                                {t('Next')}
                              </button> */}
                              <button
                                type="button"
                                class="btn btn-primary"
                                data-dismiss="modal"
                              >
                                {t('Submit')}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <!-- Add Parts --> */}

                      {/* <!-- Starting system --> */}
                      {/* <div
                        class="modal fade"
                        id="starting-system-modal"
                        tabindex="-1"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                      >
                        {getSpareParts !== undefined && getSpareParts.length > 0
                          ? getSpareParts
                              .filter(
                                (data) => data.partId === parts[index1].partId
                              )
                              .map((item) => {
                                return (
                                  <>
                                    <div class="modal-dialog modal-dialog-scrollable modal-lg">
                                      <div class="modal-content">
                                        <div class="modal-header">
                                          <h5 class="modal-title">
                                            {partLabel(item)}
                                          </h5>
                                          <button
                                            type="button"
                                            class="close"
                                            data-dismiss="modal"
                                            aria-label="Close"
                                          >
                                            <span aria-hidden="true">
                                              &times;
                                            </span>
                                          </button>
                                        </div>
                                        <div class="modal-body">
                                          <h5 class="mb-4">
                                            {t(
                                              'Just click on Product you deals in                        and save'
                                            )}
                                          </h5>
                                          <div class="add-car-brands-wrap">
                                            <div class="row">
                                              {item?.partProducts !==
                                                undefined &&
                                              item?.partProducts.length > 0
                                                ? item?.partProducts?.map(
                                                    (item) => {
                                                      return (
                                                        <>
                                                          <div class="col-6 col-sm-6 col-md-2 mb-4">
                                                            <div
                                                              class="car-brands-block"
                                                              onClick={(e) =>
                                                                handleAddProduct(
                                                                  e,
                                                                  indexValue,
                                                                  item?.product
                                                                    ?.productId,
                                                                  item?.productId
                                                                )
                                                              }
                                                            >
                                                              <div
                                                                class="car-brands-a"
                                                                style={{
                                                                  border:
                                                                    slectedProduct.includes(
                                                                      item.productId
                                                                    )
                                                                      ? '3px solid #0d6efd' // Bootstrap blue
                                                                      : '2px solid #dee2e6', // Light gray
                                                                  backgroundColor:
                                                                    slectedProduct.includes(
                                                                      item.productId
                                                                    )
                                                                      ? '#e7f1ff' // Light blue background
                                                                      : 'white',
                                                                  borderRadius:
                                                                    '12px',
                                                                  padding:
                                                                    '10px',
                                                                  position:
                                                                    'relative',
                                                                  transition:
                                                                    'all 0.3s ease-in-out',
                                                                }}
                                                              >
                                                                <img
                                                                  src={
                                                                    item
                                                                      ?.product
                                                                      ?.media
                                                                      ?.path
                                                                  }
                                                                  alt=""
                                                                  class="img-fluid"
                                                                  style={{
                                                                    width:
                                                                      '100%',
                                                                    height:
                                                                      'auto',
                                                                    display:
                                                                      'block',
                                                                  }}
                                                                />
                                                              </div>

                                                              <div class="car-brands-b">
                                                                {
                                                                  item?.product
                                                                    ?.name
                                                                }
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </>
                                                      );
                                                    }
                                                  )
                                                : ''}
                                            </div>
                                          </div>
                                        </div>

                                        <div class="modal-footer">
                                          <button
                                            type="button"
                                            class="btn btn-primary"
                                            data-dismiss="modal"
                                          >
                                            {t('Submit')}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                );
                              })
                          : ''}
                      </div> */}
                    </>
                  );
                })}

                {/* [CF] Submit belongs to the add-form — show only while adding,
                    and disable (grey out) until at least one valid part is
                    selected so it can't report success with nothing added. */}
                {isAdding && (
                <div class="row mt-5 ">
                  {/* <div class="col-6">
                    <button
                      type="reset"
                      // onClick={ResetHendler}
                      class="btn btn-secondary btn-block"
                      href="#"
                      // onClick={ResetHendler}
                      // role='button'
                    >
                      {t('Reset')}
                    </button>
                  </div> */}
                  <div class="col-6">
                    <button
                      type="submit"
                      disabled={!hasValidPart}
                      // to='/sp-garages-packages'
                      className="btn btn-warning btn-block"
                      // href='sp-garages-manage-business-packages.html'
                      // role='button'
                    >
                      {t('Submit')}
                    </button>
                    {/* {isPaymentPlanActive == 'true' ? (
                    ) : (
                      <a
                        class="btn btn-warning btn-block"
                        href="#/manage-package"
                        role="button"
                      >
                        Buy Subscription
                      </a>
                    )} */}
                  </div>
                </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
